import http from '@/base/api/public'
import querystring from 'querystring'

let apiUrl = require('@/../config/sysConfig')
// マイカー出勤申請確認 API「スタッフ申請確認ログ保存」
export const i_0013_confirmlog = (params, userCd) => {
  return http.requestPost(apiUrl.apiUrl_StaffApplyConfirmLog + '?userCd=' + userCd, [params]);
}
//マイカー出勤申請確認 API「マイカー使用有無検索」
export const i_0013_mycarusecheck = (userCd) => {
  return http.requestQuickGet(apiUrl.apiUrl_myCarUseInfo + '?userCd=' + userCd)
}
// メニュー状態管理検索
export const menuStateManagerGet = (userCd) => {
  return http.requestGet(apiUrl.apiurl_MenuStateManager + '?userId=' + userCd)
}



// WEBPACK FOOTER //
// ./src/module/api/i_0013.js